export const SIGNUP = 'SIGNUP';
export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const SYNC_USER_TO_DB = 'SYNC_USER_TO_DB';
export const SAVE_CANVAS = 'SAVE_CANVAS';
export const CLEAR_CANVAS = 'CLEAR_CANVAS';
export const SET_AUDIO_FILE = 'SET_AUDIO_FILE';
export const DECODE_AUDIO_BUFFER = 'DECODE_AUDIO_BUFFER';
export const CLEAR_AUDIO_FILE = 'CLEAR_AUDIO_FILE';
export const JOB_UPDATE = 'JOB_UPDATE';
export const JOB_CREATE = 'JOB_CREATE';
export const POLL_VIDEO_CREATION = 'POLL_VIDEO_CREATION';
export const POLL_ZUBTITLE_FINALIZATION = 'POLL_ZUBTITLE_FINALIZATION';
export const POLL_ZUBTITLE_TRANSCRIPTION = 'POLL_ZUBTITLE_TRANSCRIPTION';
export const CREATE_WAVVE_LINK = 'CREATE_WAVVE_LINK';
export const UPDATE_WAVVE_LINK = 'UPDATE_WAVVE_LINK';
export const DELETE_THEME = 'DELETE_THEME';
export const FETCH_MAILING_LIST_SUBSCRIBERS = 'FETCH_MAILING_LIST_SUBSCRIBERS';
export const SUBSCRIBE_TO_MAILING_LIST = 'SUBSCRIBE_TO_MAILING_LIST';
export const SET_CUSTOM_DOMAIN = 'SET_CUSTOM_DOMAIN';
export const REMOVE_CUSTOM_DOMAIN = 'REMOVE_CUSTOM_DOMAIN';
